import {
    GetPrescriptionPdfByTokenDto,
    IRequestConfig,
    IRequestOptions,
    ShApiResponse_GetPrescriptionPdfDto,
    axios,
    basePath,
    getConfigs,
} from "./index.defs";

export class SubscriptionsApiService {
    static ecgsGetPrescriptionPdfByToken(
        params: {
            /**  */
            prescriptionDto: GetPrescriptionPdfByTokenDto;
            /** access token */
            authorization?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ShApiResponse_GetPrescriptionPdfDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/subscriptions/prescription";

            options.headers = {
                Authorization: params["authorization"],
                ...options.headers,
            };
            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params["prescriptionDto"];

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}
